import { flatten } from '@higo/api/src/utils';
import { UnknownDictionary } from '@summer/jst-dictionaries';
import { AxiosInstance } from 'axios';

export const fetchDictionary = (axios: AxiosInstance) => () =>
  axios.get<UnknownDictionary>('api/dictionary/list').then(flatten);
